import { chain } from "wagmi";
import fancyBearsNftAbi from "./abis/fancyBears.abi.json";
import honeyJarsNftAbi from "./abis/honeyJars.abi.json";
import en from "./locales/en.json";
import gl from "./goldlist.csv";

export { default as theme } from "./theme";

export const apiUrl = process.env.REACT_APP_API_URL;
export const metadataUrl = process.env.REACT_APP_METADATA_URL;
export const filestoreUrl = process.env.REACT_APP_FILESTORE_URL;

export const fancyBearsOpenSeaUrl =
  process.env.REACT_APP_FANCY_BEARS_OPENSEA_URL;
export const honeyJarsOpenSeaUrl = process.env.REACT_APP_HONEY_JARS_OPENSEA_URL;

export const chainName = process.env.REACT_APP_CHAIN_NAME;
export const infuraId = process.env.REACT_APP_INFURA_ID;

// @ts-expect-error
export const chains = [chain[process.env.REACT_APP_CHAIN_NAME!]];

export const fancyBearsContract = {
  address: process.env.REACT_APP_FANCY_BEARS_ADDRESS!,
  interface: fancyBearsNftAbi,
};

export const honeyJarsContract = {
  address: process.env.REACT_APP_HONEY_JARS_ADDRESS!,
  interface: honeyJarsNftAbi,
};

export const fancyBearsHoneyScalar = parseInt(
  process.env.REACT_APP_FANCY_BEARS_HONEY_SCALAR!
);

export const honeyJarsHoneyScalar = parseInt(
  process.env.REACT_APP_HONEY_JARS_HONEY_SCALAR!
);

export const locales = {
  en,
};

export const goldlist = gl as [address: string, maxCount: number][];

export const learnMoreUrl = process.env.REACT_APP_LEARN_MORE_URL;
